import styled from 'styled-components/macro'

const LoaderContainer = styled.div`
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  background-image: none;
  display: flex;
  align-items: center;
  justify-content: center;
`

export { LoaderContainer }
